export const FETCH_LEX_FAVORITE = 'FETCH_LEX_FAVORITE';
export const LEX_FAVORITE_SUCCESS = 'LEX_FAVORITE_SUCCESS';
export const LEX_FAVORITE_ERROR = 'LEX_FAVORITE_ERROR';
